module.exports = __webpack_public_path__ + "static/media/case-id-tooltip-en.888cedec.jpg";